export default __webpack_public_path__ + "static/media/cross.7d938e26.svg";